export const NBSP = ' ';
